import { render, staticRenderFns } from "./GiftCardTicketBoxRevertBtn.vue?vue&type=template&id=a5e59ea8&"
import script from "./GiftCardTicketBoxRevertBtn.vue?vue&type=script&lang=js&"
export * from "./GiftCardTicketBoxRevertBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports